import { APP_TAGLINE } from "@custos/core";
import { Logo, NetworkBadge, SystemMessages } from "@custos/ui";
import type { ReactNode } from "react";
import { useConfig, usePublicMessages } from "../lib/queries";

/** Signed-out screens: a frosted card floating over the pastel sky (D88). */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  const config = useConfig();
  const notices = usePublicMessages();
  return (
    <div className="flex min-h-dvh flex-col items-center px-4 pt-5 pb-10">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-between gap-3 sm:mb-12">
          <Logo />
          {config.data && <NetworkBadge label={config.data.badge} />}
        </div>
        <div className="mb-6 px-1 text-center">
          <h1 className="font-heading text-[32px] leading-tight font-semibold tracking-[-0.03em] text-fg">
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-base text-muted">{subtitle}</p>}
        </div>
        {/* Team notices marked for the login page (D78): everyone sees them, nothing to close. */}
        <SystemMessages className="mb-4" messages={notices.data ?? []} />
        <div className="glass animate-rise rounded-[32px] p-5 sm:p-7">{children}</div>
        <p className="mt-6 text-center text-xs text-muted">{APP_TAGLINE}</p>
      </div>
    </div>
  );
}
